<button
    type="button"
    id="unscaleToolBtn"
    class="btn btn-default nlr-icon-btn"
    [title]="getTooltip()"
    [ngClass]="{active: isActive()}"
    (click)="onClick()"
    [disabled]="disabled">
    <i
        class="nlrp-icon"
        [ngClass]="{'nlrp-icon-scaled-annotation': active, 'nlrp-icon-unscaled-annotation': !active}"></i>
</button>
